import AgencyOverview from '@/components/routes/agency/AgencyOverview'
import AgencySettings from '@/components/routes/agency/agencySettings/AgencySettings'

import AgencyAgents from '@/components/routes/agency/AgencyAgents'
import AgencyContracts from '@/components/routes/agency/AgencyContracts'
import AgencyStatements from '@/components/routes/agency/AgencyStatements'

const agencyRoutes = [
  {
    name: 'agency',
    path: '/agency',
    redirect: {
      name: 'agencySettings'
    },
    component: AgencyOverview
  },
  {
    name: 'agencySettings',
    path: '/agency/settings',
    component: AgencySettings
  },
  {
    name: 'agencyAgents',
    path: '/agency/agents',
    component: AgencyAgents
  },
  {
    name: 'agencyContracts',
    path: '/agency/contracts',
    component: AgencyContracts
  },
  {
    name: 'agencyStatements',
    path: '/agency/statements',
    component: AgencyStatements
  }
]

export default agencyRoutes
